import { StatusModel } from "../../general";

export interface HistoryModel {
  status: StatusModel;
  time: string;
  value: number;
}
